import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-item-id"]
const _hoisted_2 = { class: "spec flex" }
const _hoisted_3 = {
  key: 0,
  class: "spec col"
}
const _hoisted_4 = {
  key: 0,
  class: "header-text"
}
const _hoisted_5 = {
  key: 2,
  class: "estimated-price-container no-line-through"
}
const _hoisted_6 = { class: "estimated-price-header" }
const _hoisted_7 = { class: "estimated-price-content" }
const _hoisted_8 = {
  key: 1,
  class: "spec col"
}
const _hoisted_9 = { class: "header-text" }
const _hoisted_10 = { class: "content-text price" }
const _hoisted_11 = {
  key: 2,
  class: "shop-product-prices spec"
}
const _hoisted_12 = {
  key: 0,
  class: "estimated-price-container"
}
const _hoisted_13 = { class: "estimated-price-header" }
const _hoisted_14 = { class: "estimated-price-content" }
const _hoisted_15 = { class: "content-text price" }

import { type PropType } from "vue";
import { formatAmount } from ".";

import labels from "../../../../shared/labels";
import { type OverwriteSettings } from "../../../../../commons/product/overwrite-settings";

import { undefinedIfNullOrWhiteSpace } from "../../../../../../shared/utils/string";


export default /*@__PURE__*/_defineComponent({
  __name: 'product-specs',
  props: {
    productId: Number,
    isAuction: Boolean,
    isBuynow: Boolean,
    isShop: Boolean,
    hasBid: Boolean,
    mobile: Boolean,
    productEstimatedValue: Number,
    priceComparisonEnabled: Boolean,
    price: Number,
    overwriteSettings: Object as PropType<OverwriteSettings>,
},
  setup(__props) {



//const instance = getCurrentInstance();

// const regionInfoBlocks = computed(() => {
//     const result : {headerText: string, contentText: string, tooltip? : boolean, html? : boolean }[] = [];
//     if (props.mobile) return result;
//     const item = props.item;
//     if (!item.showRegionInfo) return result;
//     if (!props.isShop) {
//         if (item.hasFreightMethods) {
//             let content;
//             if (item.hasMultipleFreightMethods) {
//                 content = string.format(
//                     labels.frontendProductList.productSpecs.values
//                         .deliveryFromPrice,
//                     formatAmount(item.freightPrice)
//                 );
//             } else {
//                 content = formatAmount(item.freightPrice);
//             }
//             result.push({
//                 headerText:
//                     labels.frontendProductList.productSpecs.headers
//                         .deliveryLabel,
//                 contentText: content ?? "",
//             });
//         } else if (item.deliverySpecify) {
//             let content = "";
//             if (item.deliveryPrice != null) {
//                 content += formatAmount(item.deliveryPrice) + "<br/>";
//             }
//             content += string.format(
//                 labels.frontendProductList.productSpecs.values
//                     .deliveryTextEmail,
//                 item.deliveryContact
//             );
//             result.push({
//                 headerText:
//                     labels.frontendProductList.productSpecs.headers
//                         .deliveryLabel,
//                 contentText: content,
//                 tooltip: true,
//                 html: true,
//             });
//         }

//         if (item.hasPickupData) {
//             result.push({
//                 headerText:
//                     labels.frontendProductList.productSpecs.headers.pickupLabel,
//                 contentText: item.pickupHint,
//                 tooltip: true,
//             });
//         }
//     }

//     if (item.showRegionInfo) {
//         result.push({
//             headerText:
//                 labels.frontendProductList.productSpecs.headers.regionLabel,
//             contentText: item.regionText,
//             tooltip: true,
//         });
//     }

//     if (item.hasExperienceInfo) {
//         result.push({
//             headerText:
//                 labels.frontendProductList.productSpecs.headers.experienceLabel,
//             contentText: item.experienceText,
//             tooltip: true,
//         });
//     }
//     return result;
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            specsToUpdate: false,
            'auction-and-buynow': __props.isAuction && __props.isBuynow,
            'price-comparison-enabled': __props.priceComparisonEnabled,
        }),
    "data-item-id": __props.productId,
    "data-item-type": "product"
  }, [
    _createElementVNode("div", _hoisted_2, [
      (__props.isAuction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (__props.price != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (!__props.hasBid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(labels).frontendProductList.productSpecs.headers
                                    .minimumPrice) + ": ", 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(labels).frontendProductList.productSpecs.headers
                                    .currentBid) + ": ", 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            (__props.price != null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([
                            'content-text',
                            'price',
                            _ctx.$style['highlight-cyan'],
                        ])
                }, _toDisplayString(_unref(formatAmount)(__props.price)), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            (__props.productEstimatedValue != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(undefinedIfNullOrWhiteSpace)(
                                    __props.overwriteSettings?.overwriteEstimateLabel
                                ) ??
                                _unref(labels).frontendProductList.productSpecs.headers
                                    .estimatedValue) + ": ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatAmount)(__props.productEstimatedValue)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (__props.isBuynow && !__props.priceComparisonEnabled && __props.price != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(labels).frontendProductList.productSpecs.headers
                            .buyNowPrice), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formatAmount)(__props.price)), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (__props.isShop && __props.price != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (
                        __props.productEstimatedValue != null &&
                        (__props.price == null || __props.productEstimatedValue > __props.price)
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(undefinedIfNullOrWhiteSpace)(
                                __props.overwriteSettings?.overwriteEstimateLabel
                            ) ??
                            _unref(labels).frontendProductList.productSpecs.headers
                                .shopEstimatedPrice) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(formatAmount)(__props.productEstimatedValue)), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(formatAmount)(__props.price)), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (!__props.mobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
                    'spec no-border-after rel overlay-popup': true,
                    'no-border-before': __props.isShop,
                })
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }),
    _createCommentVNode(" <template v-if=\"regionInfoBlocks.length > 0\">\r\n            <div class=\"spec flex productlist-geospecs specs\">\r\n                <template v-for=\"regionInfoBlock in regionInfoBlocks\">\r\n                    <div\r\n                        class=\"spec col\"\r\n                        :key=\"regionInfoBlocks.indexOf(regionInfoBlock)\"\r\n                    >\r\n                        <div class=\"header-text\">\r\n                            {{ regionInfoBlock.headerText }}\r\n                        </div>\r\n                        <div class=\"content-text\">\r\n                            <template v-if=\"regionInfoBlock.tooltip === true\">\r\n                                <span class=\"tooltip-hint\">\r\n                                    <template v-if=\"regionInfoBlock.html\">\r\n                                        <span\r\n                                            class=\"down\"\r\n                                            v-html=\"regionInfoBlock.contentText\"\r\n                                        ></span>\r\n                                    </template>\r\n                                    <template v-else>\r\n                                        <span class=\"down\">\r\n                                            {{ regionInfoBlock.contentText }}\r\n                                        </span>\r\n                                    </template>\r\n                                </span>\r\n                            </template>\r\n                            <template v-else>\r\n                                <template v-if=\"regionInfoBlock.html\">\r\n                                    <span\r\n                                        v-html=\"regionInfoBlock.contentText\"\r\n                                    ></span>\r\n                                </template>\r\n                                <template v-else>\r\n                                    {{ regionInfoBlock.contentText }}\r\n                                </template>\r\n                            </template>\r\n                        </div>\r\n                    </div>\r\n                </template>\r\n            </div>\r\n        </template> ")
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})